import { ComponentSingleStyleConfig } from '@chakra-ui/react'

export const Progress: ComponentSingleStyleConfig = {
  baseStyle: {
    filledTrack: {
      bg: 'brand.ultramarine',
    },
  },
}
